import React, { Component } from 'react';
import '../App.css';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';

class NoMatch extends Component {
  render() {
    const { embed } = this.props;
    if (embed) {
      return <div className="HomeBlock">
              <div className="content">
                <h1>Erreur 404</h1>
                <p>Page introuvable... :(</p>
              </div>
            </div>

    } else {
    return <div className="AppContent">
    <ScrollToTopOnMount/>
    <div className="HomeBlock" id="Error404">
      <div className="wrapper">
        <div className="content">
          <h1>Erreur 404</h1>
          <p>Page introuvable... :(</p>
        </div>
      </div>
    </div>
  </div>
}
  }
}

  export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js